import { render, staticRenderFns } from "./Grid-public.vue?vue&type=template&id=19fc9ff1&scoped=true&lang=pug"
import script from "./Grid-public.vue?vue&type=script&lang=js"
export * from "./Grid-public.vue?vue&type=script&lang=js"
import style0 from "./Grid-public.vue?vue&type=style&index=0&id=19fc9ff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc9ff1",
  null
  
)

export default component.exports